import React from 'react';
import AnalisiCommercialeGo from './AnalisiCommercialeGo';

/**
 * Costi - fornitori: dati di acquisto letti dal gestionale GO.
 *
 * Sul ciclo passivo la data di riferimento e' la **data di registrazione**,
 * cioe' la competenza contabile, non la data documento. Non e' un dettaglio:
 * 2.418 fatture d'acquisto su 2.825 hanno le due date diverse e 94 cadono in
 * un anno differente. L'API lo gestisce da se' e dichiara la colonna usata:
 * la pagina la mostra, cosi' chi legge sa su quale criterio e' costruito il
 * totale.
 */

export default function CostiFornitoriGoPage() {
  return (
    <AnalisiCommercialeGo
      ciclo="passivo"
      titolo="Costi - fornitori"
      introduzione={
        'Costi di acquisto letti da Gestionale Open, aggregati per fornitore. ' +
        'Le date sono quelle di registrazione, cioè la competenza contabile: su GO ' +
        'la maggior parte delle fatture d\'acquisto ha data documento diversa. ' +
        'I totali li calcola il database, con le note di credito già sottratte.'
      }
    />
  );
}
